export default __webpack_public_path__ + "static/media/connector.25b0fbfd.png";